import { Component, OnInit } from '@angular/core';
import { StandardApiError, LoginData, SecurityQuestions } from '@tecommon/structures/structures';
import { HttpClient } from '@angular/common/http';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HeaderEventService } from '@tecommon/ui/components/teHeader/teHeader.component';
import { TranslateService } from '@ngx-translate/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { LocalStorage } from '@tecommon/ui/components/localStorage/localStorage.service';
import { Globals } from '../../../@tecommon/ui/components/global/globals';
import { SessionCheck } from '../../services/sessionCheck/sessionCheck.service';
declare var document: any;

@Component({
    selector: 'login-second-factor',
    templateUrl: './loginSecondFactor.component.html',
    providers: [Globals
    ],
    animations: [
        trigger('dropIn', [
            transition(':enter', [
                style({ height: 0, opacity: 0 }),
                animate('500ms', style({ height: '*', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: '*', opacity: .7 }),
                animate('500ms', style({ height: 0, opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
/** loginSecondFactor component*/
export class LoginSecondFactorComponent implements OnInit {
    public userId: string;
    public lastUserId: string;
    public returnUrl: string;
    public loadingQuestions: boolean;
    public emailSent: boolean = false;
    public successMessage: string;
    public errorMessage: string;
    public signInOption: string;
    public hidePassword: boolean = true;
    public hideQuestion1: boolean = true;
    public hideQuestion2: boolean = true;
    public loggingIn: boolean = false;
    public login: LoginData;
    public standardError: StandardApiError;
    public isPINRegistered: boolean = false;
    public password = new FormControl('', [Validators.required]);
    public duoPasscode = new FormControl('', [Validators.required]);
    public question1 = new FormControl('', [Validators.required]);
    public question2 = new FormControl('', [Validators.required]);
    public _translateService: TranslateService;
    public btnDynamic: string = 'SignIn';
    public userAccessType: string;
    
    public loadingEmailSentStatus: boolean = false;
    public hideEmailPasscode: boolean = true;
    public emailPasscode = new FormControl('', [Validators.required]);
    private resendDisabled: boolean = false;
    /** loginSecondFactor ctor */
    constructor(private readonly http: HttpClient, private readonly translate: TranslateService,
        private readonly router: Router, private readonly activatedRoute: ActivatedRoute,
        private readonly headerEvents: HeaderEventService, private readonly localStorage: LocalStorage, private globals: Globals,
        private readonly sessionCheck: SessionCheck)
    {
        
        this.login = {} as LoginData;
        this._translateService = translate;
        this.btnDynamic = 'SignIn';
        document.language = (this.localStorage.getItem("language") === null
            || this.localStorage.getItem("language") === ""
            || this.localStorage.getItem("language") === "undefined") ? "en" : this.localStorage.getItem("language");
        this.getuserAccessType();

        this.getSignIn2Options();     

        this.headerEvents.languageChanged.subscribe((p) => {
            this.getSignIn2Options();
            this.getQuestions(); 
        });
        

        //back button disable [started]
        history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', function (event) {
            history.pushState(null, null, window.location.href);
        });
        // back button disable [ended]
        this.ClearCookieWhenCloseWindowOrTab();
        this.SessionTimeOutCheck();
    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(
            (params: Params) => this.returnUrl = params["ReturnUrl"]);
    }

    public getuserAccessType(): any {
        this.globals.getUserInfo().subscribe(result => {
            //console.log(result);
            this.userAccessType = result;
            // btnSubmit  disabled = !userId || loggingIn || emailPasscode.invalid
            if (this.userAccessType === "INTERNAL") {
                this.password = new FormControl('', [Validators.required, Validators.minLength(8)]);
                this.duoPasscode = new FormControl('', [Validators.required, Validators.minLength(4)]);
                this.question1 = new FormControl('', [Validators.required, Validators.minLength(3)]);
                this.question2 = new FormControl('', [Validators.required, Validators.minLength(3)]);

            } else {
                this.password = new FormControl('', [Validators.required, Validators.minLength(1)]);
                this.duoPasscode = new FormControl('', [Validators.required, Validators.minLength(1)]);
                this.question1 = new FormControl('', [Validators.required, Validators.minLength(1)]);
                this.question2 = new FormControl('', [Validators.required, Validators.minLength(1)]);
            }
        });

    }

    public getSignIn2Options(): void {
                       this.http.get<LoginData>("/api/Login/2FOptions", { params: { culture: document.language } }).subscribe(result => {
                this.login = result;
            this.isPINRegistered = this.login.isPINRegistered;
            this.userId = this.login.userId;
        },
            error => {
                console.log('error'+ error.error);
                this.loggingIn = false;
                if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                    this.errorMessage = "LoginExpired";
                } else {
                   
                    console.log(error.error.message);
                    this.errorMessage = "FatalErrorMsg";
                }
            });
    }

    public clearControls(): void {
        this.errorMessage = null;
        this.successMessage = null;
        this.password.reset('');
        this.question1.reset('');
        this.question2.reset('');
        this.duoPasscode.reset('');
        this.loggingIn = false;
        this.loadingQuestions = false;
        this.emailSent = false;
        this.btnDynamic = 'SignIn';
    }

    public optionChanged(): void {

        //login.securityQuestions are set to NULL to stop displaying questions from previous selection before displaying the new set of questions
        this.login.securityQuestions = null;
        this.clearControls();

        if (this.signInOption === 'questions') {
            this.getQuestions();
        }
        if (this.signInOption === 'external_email') {
            this.sendNewEmail();
        }
        this.successMessage = null;
    }

    public getQuestions(): void {
        this.successMessage = this.errorMessage = null;
        this.btnDynamic = 'SignIn';
        //console.log('userId' + this.userId);
        if (!this.userId) return;
        this.loadingQuestions = true;
        this.http.get<SecurityQuestions[]>('/api/Login/' + this.userId + '/' + document.language + '/Questions').subscribe(result => {
            this.login.securityQuestions = result;
                    this.loadingQuestions = false;
            },
            error => {
                console.log(error);
                this.loadingQuestions = false;
                this.login.securityQuestions = null;

                if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                    this.errorMessage = "LoginExpired";
                } else {
                    this.errorMessage = "FatalErrorMsg";
                }
            });
    }

    public cancel(): void {
        this.clearControls();
        // Make the dropdown menu selection changed to default whenever user id is changed
        this.signInOption = null;
    }

    public submit2FLogin(): void {
        this.successMessage = this.errorMessage = this.standardError = null;
        if (this.loggingIn) return; // Don't allow another login attempt while one is already happening.
        this.loggingIn = true;
        // clear entries for new login attempt.
        this.login.password = this.login.mfaPasscode = this.login.securityAnswer1 = this.login.securityAnswer2 = null;
        switch (this.signInOption) {
        case 'password':
                this.login.password = this.password.value;
                break;
        case 'questions':
            if (this.login.securityQuestions) {
                this.login.securityAnswer1 = this.question1.value;
                this.login.securityAnswer2 = this.question2.value;
                this.login.securityQuestionId1 = this.login.securityQuestions[0].securityQuestionId;
                this.login.securityQuestionId2 = this.login.securityQuestions[1].securityQuestionId;
                break;
            }
        case 'external_email':
            this.login.externalEmailIdCode = this.emailPasscode.value;
            break;
        }
        this.login.culture = document.language;
        this.login.isThisTwoFactorAuth = true;
        this.http.post<StandardApiError>("/api/Login/" + this.userId, this.login).subscribe(result => {
                    // We received a redirect to a specific URL along with our logon cookie!
            try {

                   window.onbeforeunload = null;//clear cookie if user closed window/tab

                    if (this.returnUrl) {
                        this.standardError = result;

                        if (this.standardError.name == "lockstatus" && this.standardError.message == "true") {
                            window.location.replace("/Main/UnlockAccount");
                        } else {
                            if (this.standardError.needsLoadModel != "") {
                                this.localStorage.setItem("firstTimeRegistration", this.standardError.needsLoadModel);
                            }
                            window.location.replace(this.returnUrl);
                        }
                    }
                    else {
                        this.standardError = result;
                        if (this.standardError.name == "lockstatus" && this.standardError.message == "true") {
                            window.location.replace("/Main/UnlockAccount");
                        } else {
                            if (this.standardError.needsLoadModel != "") {
                                this.localStorage.setItem("firstTimeRegistration", this.standardError.needsLoadModel);
                            }
                            window.location.replace("/Main/Home");
                        }
                    }
            } catch (e) {
                        console.log("window.location.replace is not working: " + e);
                        this.errorMessage = "FatalErrorMsg";
                        this.btnDynamic = 'SignIn';
                        this.loggingIn = false;
                    }
            },
            error => {
                console.log(error.error);
                var _error = error.error;
                this.btnDynamic = 'SignIn';
                if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                    this.errorMessage = "LoginExpired";
                } else {

                    switch (this.signInOption) {
                        case 'password':
                            this.errorMessage = 'NetworkFailureMsg';
                            this.password.setValue('');
                            this.password.markAsDirty();
                            this.password.markAsTouched();
                            break;
                        case 'questions':
                            this.errorMessage = 'SecurityFailureMsg';
                            this.question1.setValue('');
                            this.question1.markAsDirty();
                            this.question1.markAsTouched();
                            this.question2.setValue('');
                            this.question2.markAsDirty();
                            this.question2.markAsTouched();
                            break;
                        case 'external_email':
                            if (_error.name === 'NOT_REGISTERED_EMAIL' || _error.name === 'OTP_ENTERED_AFTER_30MIN') {
                                this.errorMessage = 'ExtInvalidOTP';
                            } else if (_error.name === 'EXCEPTION' || _error.name === 'INCORRECT_USER_ID_OR_CREDENCIAL') {
                                this.errorMessage = 'NetworkFailureMsg';
                            } else if (_error.name === 'INVALID_AUTHENTICATION') {
                                this.errorMessage = 'NetworkFailureMsg';
                            } else if (_error.name === 'INVALID_OTP') {
                                this.errorMessage = 'ExtInvalidOTP';
                            }
                            else {
                                this.errorMessage = 'NetworkFailureMsg';//default
                            }
                            this.emailPasscode.setValue('');
                            this.emailPasscode.markAsDirty();
                            this.emailPasscode.markAsTouched();
                            break;

                    }
                }
                this.loggingIn = false;

            });
    }
    public passwordResetPIN(): void {
        window.onbeforeunload = null;//clear cookie if user closed window/tab
    }
    public ClearCookieWhenCloseWindowOrTab(): void {

            window.onbeforeunload = function (e) {
                console.log('when, window / tab got closed')
                const date = new Date();
                const cookieName = 'myID.PeanutButterChocolateChip';
                let cookieValue = '';
                const nameEQ = encodeURIComponent(cookieName) + "=";
                const ca = document.cookie.split(';');
                for (let i = 0; i < ca?.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) === ' ') c = c.substring(1, c?.length);
                    if (c.indexOf(nameEQ) === 0) {
                        cookieValue = c.substring(nameEQ?.length, c?.length);  //decodeURIComponent(
                    }
                }
                document.cookie = `${cookieName}=${cookieValue}; Path=/; Expires=${date.toUTCString()}`;
                //end clear all the cookies values
                return 'confirmation text to window / tab .';
            };
    }

    public SessionTimeOutCheck(): void {

        this.sessionCheck.watch(); // Our idle session watch service.
    }

    public sendNewEmail(): void {

        if (this.resendDisabled) {
            return;
        }

        this.resendDisabled = true;

        setTimeout(() => {
            this.resendDisabled = false;
        }, 60000);

        this.successMessage = this.errorMessage = null;
        this.loadingEmailSentStatus = true;
        try {
            this.http.get<boolean>('/api/Login/SendEmailPasscode/' + this.userId + "/" + document.language).subscribe(
                result => {
                    this.loadingEmailSentStatus = false;
                    //this.emailSent = result === "true" ? true : false;
                    this.emailSent = result as boolean;
                    if (!this.emailSent) {
                        this.errorMessage = 'FatalErrorMsg';
                        this.successMessage = null;
                    }
                },
                error => {
                    this.loadingEmailSentStatus = false;
                    this.emailSent = false;
                    this.errorMessage = 'FatalErrorMsg';
                    this.successMessage = null;
                    console.log(error.error.message);
                });
        }
        catch (e) {
            console.log("External Email Authetication - Send Identification Code is NOT working:" + e);
            this.loadingEmailSentStatus = false;
            this.errorMessage = 'FatalErrorMsg';
            this.successMessage = null;
        }
    }
}